export default __webpack_public_path__ + "static/media/sumeru1.50f85539.png";